import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function usePlacementScrapingRunConfig() {
  return useCbhFlag(CbhFeatureFlag.PLACEMENT_SCRAPING_RUN, {
    defaultValue: {
      enabled: false,
      dryRunEnabled: true,
    },
  });
}
